module.exports = __webpack_public_path__ + "static/media/tidepool-t-copy.a8f07ef7.svg";